/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutPaymentMethodController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'PaymentMethod';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.Selected = 0;
            $scope.Control.SelectedItem = undefined;

            if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.ExtendControl === 'function') {
                $.extend($scope.Control, checkoutOverrides.Payment.ExtendControl($scope.Control, $element));
            }

            var initiallyValidated = false;

            var savedData = new SavedDataState();

            var shScope = angular.element('.x-control.x-angular-control.x-checkoutshippingmethod').scope();

            $scope.Control.setSelected = function (paymentMethodId, paymentProcessorId, availablePaymentMethodIs) {

                if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.CheckIfNotAvailable === 'function') {
                    if (checkoutOverrides.Payment.CheckIfNotAvailable(paymentMethodId)) {
                        return false;
                    }
                }

                var selectedMethod = getSelectedPaymentMethod(paymentMethodId, paymentProcessorId, availablePaymentMethodIs);

                $scope.Control.Selected = selectedMethod ? selectedMethod.Id : 0;
                $scope.Control.SelectedItem = selectedMethod;
                $scope.setControlValue(controlName, selectedMethod);
                validate();
                $scope.Control.applyChanges();
            };

            var getSelectedPaymentMethod = function (paymentMethodId, paymentProcessorId, availablePaymentMethodIs) {

                if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.GetSelected === 'function') {
                    return checkoutOverrides.Payment.GetSelected(paymentMethodId, paymentProcessorId, availablePaymentMethodIs, $scope.Model.Data.Methods, $scope.Control, $scope.$parent.Order.Current);
                }

                var selectedMethod = paymentProcessorId > 0
                    ? _.first(_.filter($scope.Model.Data.Methods, function (x) { return x.Id == paymentMethodId && x.ProcessorId == paymentProcessorId && x.IsSelectable; }))
                    : _.first(_.filter($scope.Model.Data.Methods, function (x) { return x.Id == paymentMethodId && x.IsSelectable; }));

                var cost = $scope.$parent.Order.Current.TotalCost;

                if (availablePaymentMethodIs && typeof selectedMethod !== 'undefined') {

                    var filteredMethods = [];
                    jQuery.grep($scope.Model.Data.Methods, function (elem) {
                        if (jQuery.inArray(elem.Id, availablePaymentMethodIs) > -1) filteredMethods.push(elem);
                    });

                    if (cost > 0) {
                        selectedMethod = paymentMethodId > 0
                            ? _.first(_.filter(filteredMethods, function (x) { return x.Id == paymentMethodId && x.ProcessorId == selectedMethod.ProcessorId && !x.IsNoPayment && x.IsSelectable; })) || _.first(_.filter(filteredMethods, function (x) { return !x.IsNoPayment && x.IsSelectable; }))
                            : _.first(_.filter(filteredMethods, function (x) { return !x.IsNoPayment && x.IsSelectable; }));

                    } else {
                        selectedMethod = paymentMethodId > 0
                            ? _.first(_.filter(filteredMethods, function (x) { return x.Id == paymentMethodId && x.ProcessorId == selectedMethod.ProcessorId && x.IsNoPayment && x.IsSelectable; })) || _.first(_.filter(filteredMethods, function (x) { return x.IsNoPayment && x.IsSelectable; }))
                            : _.first(_.filter(filteredMethods, function (x) { return x.IsNoPayment && x.IsSelectable; }));
                    }
                }

                return selectedMethod;
            };

            $scope.Control.IsMethodAvailable = function (method) {

                if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.IsMethodAvailable === 'function') {
                    return checkoutOverrides.Payment.IsMethodAvailable(method, $scope.Control, $scope.$parent.Order.Current, $scope.$parent.ShippingMethod.Current);
                }
                var existInShippingMethods = $scope.$parent.Order.Current.ShippingMethod ? method.ShippingMethods.indexOf($scope.$parent.Order.Current.ShippingMethod.MethodId) >= 0 : true;
                var cost = $scope.$parent.Order.Current.TotalCost;

                if (cost > 0) {
                    var isMethodAvailable = existInShippingMethods && !method.IsNoPayment && method.IsSelectable;
                    if (!isMethodAvailable && method.Not_Selectable_Reason === "") {
                        method.Not_Selectable_Reason = $scope.Model.Text.Checkout_PaymentMethodNonAvailable2ShippingMethod;
                    }
                    return isMethodAvailable;

                } else {
                    return method.IsNoPayment && method.IsSelectable;
                }
            };

            $scope.Control.AnyAvailableMethods = function () {
                var isAnyAvailable;

                if ($scope['Order'].Current.DeliveryPoint.Code === "onSite") {
                    if (shScope.Control.AnyAvailableMethods()) {
                        isAnyAvailable = true;
                    } else {
                        isAnyAvailable = false;
                    }
                } else if ($scope['Order'].Current.DeliveryPoint.Code === "download") {
                    isAnyAvailable = true;
                } else {
                    if ($scope['Order'].Current.Store.Id !== 0 && $scope['Order'].Current.Store.Id !== null) { 
                        isAnyAvailable = true;
                    } else {
                        isAnyAvailable = false;
                    }
                    
                }

                return isAnyAvailable;
            };

            $scope.Control.IsMethodSelected = function (selectedMethodId, selectedProcessorId, method) {
                if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.IsMethodSelected === 'function') {
                    return checkoutOverrides.Payment.IsMethodSelected(selectedMethodId, selectedProcessorId, method, $scope.Control, $scope.$parent.Order.Current);
                }
                if (!$scope.Control.IsMethodAvailable(method)) {

                    if (selectedMethodId == method.Id && selectedProcessorId == method.ProcessorId) {
                        applyModel();
                    }

                    return $scope.Control.Selected == method.Id && $scope.Control.SelectedItem.ProcessorId == method.ProcessorId;
                }

                var isSelected = selectedMethodId == method.Id && selectedProcessorId == method.ProcessorId;


                return isSelected;
            };

            var applyChanges = function (reload) {

                var deferred = $q.defer();

                //This not working properly and not recognize changes from combobox installment
                //if (!savedData.hasChanged($scope.Control.SelectedItem))
                    //return deferred.promise;

                var installments = $scope.Control.SelectedItem && $scope.Control.SelectedItem.Installments && $scope.Control.SelectedItem.Installments.AreInstallmentsEnabled
                    ? $scope.Control.SelectedItem.Installments.Values[$scope.Control.SelectedItem.Installments.SelectedIndex].Installment
                    : 0;

                ControlService.invokeCheckout($scope, $element, 'SetPaymentMethod', {
                    Name: $scope.Control.SelectedItem ? $scope.Control.SelectedItem.Name : "",
                    MethodId: $scope.Control.SelectedItem ? $scope.Control.SelectedItem.Id : 0,
                    ProcessorId: $scope.Control.SelectedItem ? $scope.Control.SelectedItem.ProcessorId : 0,
                    InstallmentsCount: installments,
                    InstallmentsData: $scope.Control.SelectedItem ? $scope.Control.SelectedItem.Installments : {},
                    Code: $scope.Control.SelectedItem ? $scope.Control.SelectedItem.Code : ""
                }).then(function (response) {
                    if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.UpdateOnSet === 'function') {
                        $scope.$parent = checkoutOverrides.Payment.UpdateOnSet($scope.$parent);
                    }
                    validate();
                    $scope.setControlValue(controlName, $scope.Control.SelectedItem);

                    savedData.setData($scope.Control.SelectedItem);

                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                    if (reload !== false) $scope['ShopAllowancesOrCharges'].Wrapper.reload();

                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            $scope.Control.applyChanges = function (reload) {
                $scope.Control.Loading = false;
                applyChanges(reload).then(function (response) {
                    if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.UpdateOnSet === 'function') {
                        $scope.$parent = checkoutOverrides.Payment.UpdateOnSet($scope.$parent);
                    }
                    if (reload !== false && $scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) === 'function') {
                        $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                            if ($scope.Config.IsExplicitTimeslotEnabled) {
                                $('.x-control.x-angular-control.x-checkoutorderexplicittimeslot').get(0).reload();
                            }
                            $scope.Control.Loading = false;
                        }, function (orderError) {
                            $scope.Control.Loading = false;
                            throw orderError;
                        });
                    }
                }, function (error) {
                    $scope.Control.Loading = false;
                    throw error;
                });
            };

            $scope.Control.applyModel = function () {
                applyModel();
            };

            var applyModel = function () {
                if ($scope['Order'] &&
                    $scope['Order'].Current &&
                    $scope['Order'].Current.PaymentMethod) {

                    var paymentMethodId = $scope['Order'].Current.PaymentMethod.MethodId;
                    var paymentProcessorId = $scope['Order'].Current.PaymentMethod.ProcessorId;
                    var availableMethodIs = $scope['Order'].Current.ShippingMethod.PaymentMethods;

                    var matchedOption = getSelectedPaymentMethod(paymentMethodId, paymentProcessorId, availableMethodIs);

                    $scope.Control.Selected = matchedOption ? matchedOption.Id : 0;

                    $scope.Control.SelectedItem = matchedOption;
                    $scope.setControlValue(controlName, matchedOption);
                    $scope.Control.applyChanges();
                    validate();
                }
            };

            var validate = function () {
                $scope.Control.IsValid = true;

                if (initiallyValidated) {
                    if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.Validate === 'function') {
                        $scope.Control.IsValid = checkoutOverrides.Payment.Validate($scope.$parent, $scope.Control);
                    } else {
                        $scope.Control.IsValid = $scope.Control.Selected != 0;
                    }

                }


            };

            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;

                initiallyValidated = true;
                validate();

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }
            };

            $element.get(0).set = function () {
                var deferred = $q.defer();                

                var installments = $scope.Control.SelectedItem.Installments && $scope.Control.SelectedItem.Installments.AreInstallmentsEnabled
                    ? $scope.Control.SelectedItem.Installments.Values[$scope.Control.SelectedItem.Installments.SelectedIndex].Installment
                    : 0;

                ControlService.invokeCheckout($scope, $element, 'SetPaymentMethod', {
                    Name: $scope.Control.SelectedItem.Name,
                    MethodId: $scope.Control.SelectedItem.Id,
                    ProcessorId: $scope.Control.SelectedItem.ProcessorId,
                    InstallmentsCount: installments,
                    InstallmentsData: $scope.Control.SelectedItem.Installments,
                    Code: $scope.Control.SelectedItem.Code
                }).then(function (response) {
                    $scope.setControlValue(controlName, $scope.Control.SelectedItem);
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            $element.get(0).reload = function () {
                var deferred = $q.defer();
                ControlService.getCheckoutData("GetPaymentMethodData", $scope, $element).then(function (response) {
                    $scope.Model = {};
                    angular.extend($scope.Model, response);
                    applyModel();
                    deferred.resolve(response);
                    $scope.Control.Loading = false;
                }, function (error) {
                    deferred.reject(error);
                    $scope.Control.Loading = false;
                });
                return deferred.promise;
            };

            $scope.$watch('Order.Current.TotalCost', function (newValue, prevValue) {

                if (!newValue && !prevValue)
                    return;

                var orScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();

                if (newValue !== prevValue && orScope.Model.Data.PaymentMethod.InstallmentsCount >  0) {
                    $element.get(0).reload();
                }
            });

            $scope.$watch('Order.Current.ProductGroupIdsString', function (newValue, prevValue) {

                if (!newValue && !prevValue)
                    return;

                if (newValue !== prevValue) {
                    $element.get(0).reload();
                }
            });

            ControlService.getCheckoutData("GetPaymentMethodData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.ExtendModel === 'function') {
                    $.extend($scope.Control, checkoutOverrides.Payment.ExtendModel($scope.Control, $scope.$parent.Order.Current));
                }
                if (checkoutOverrides && checkoutOverrides.Payment && typeof checkoutOverrides.Payment.UpdateOnInit === 'function') {
                    $scope.$parent = checkoutOverrides.Payment.UpdateOnInit($scope.$parent);
                }

                savedData.setData($scope.Control.SelectedItem);
                applyModel();

                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
        });
})();